import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";

// Иниты слайдеров только на мобилке ------------------------------------------------

import "./features/features";
import "./freelance/freelance";

// Иниты слайдеров ----------------------------------------------------------------

import "./cases/cases";
import "./process/process";
import "./testimonials/video";
import "./testimonials/messages";
import "./testimonials/tg";
import "./interviews/interviews";
import "./price-type/price-type";
import "./options/options";
